<template>
  <!-- 添加或修改设备调换记录对话框 -->
  <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="图片名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入图片名称" />
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input
          type="textarea"
          v-model="form.content"
          placeholder="请输入内容"
        />
      </el-form-item>
      <el-form-item label="类型" prop="selectType">
        <el-select
          v-model="selectType"
          filterable
          multiple
          placeholder="请选择类型(最多选择两个)"
          @change="imageTypeChange"
        >
          <el-option
            v-for="(item, index) in typeList"
            :key="index"
            :label="item.type"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="图片" prop="src">
        <image-upload v-model="form.url" :isShowTip="true" :limit="btnShow?9:1" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { imageLibraryAdd, imageLibraryUpd } from "@/api/imageLibrary";
import { imageTypeList } from "@/api/imageType";
export default {
  components: {},
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {},
      orderList: [],
      btnShow: false,
      typeList: [],
      selectType: []
    };
  },
  methods: {
    addCreateForm(platForm, userName) {
      this.reset();
      this.open = true;
      this.title = "添加图片";
      this.btnShow = true;
      this.form.platForm = platForm;
      this.form.createUser = userName;
      this.getTypeList();
    },
    showCreateForm(record) {
      this.reset();
      this.open = true;
      this.form = record;
      this.selectType = record.imageTypeList.map((item) => item.id);
    //   this.form.urls = record.url
      this.title = "修改图片";
      this.btnShow = false;
      this.getTypeList();
    },
    getTypeList() {
      imageTypeList({
        pageNum: 1,
        pageSize: 1000,
        platForm: this.form.platForm,
      }).then((response) => {
        const result = response.data.data;
        console.log(result);
        this.typeList = result.list;
      });
    },
    // 表单重置
    reset() {
      this.selectType = []
      this.form = {
        id: null,
        content: null,
        name: null,
        imageTypeList: [],
        urls: null,
        url: null,

      };
    },
    imageTypeChange(value) {
      // 如果选择的值超过2个，只保留前两个
     this.selectType = value;
      if (value.length > 2) {
        // 还原为前两个值
        this.selectType = value.slice(0, 2);
        // 可选：弹出提示
        this.$message.warning("最多只能选择2个选项！");
      }
      const result = this.typeList.filter((item) =>
        this.selectType.includes(item.id)
      );
      this.form.imageTypeList = result;
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            this.form.urls = this.form.url.split(",");
            imageLibraryUpd(this.form).then((response) => {
                if(response.data.code == 200){
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.$emit("ok");
                }
            });
          } else {
            this.form.urls = this.form.url.split(",");
            imageLibraryAdd(this.form).then((response) => {
                if(response.data.code == 200){
                    this.$modal.msgSuccess("新增成功");
                }   
                 this.open = false;
                    this.$emit("ok");
              
            });
          }
        }
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.$emit("ok");
    },
  },
  mounted() {},
};
</script>

<style></style>
